export default __webpack_public_path__ + "static/media/Bracers of Fearless Souls.9fc3724f.jpg";